<template>
  <div>
    <ts-page-title
      :title="$t('candidateCertificate.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('candidateCertificate.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-end">
        <!-- <a-button
          type="primary"
          @click="$router.push({ name: 'exam-register-create' })"
        >
          {{ $t("addNew") }}
        </a-button> -->
        <div class="tw-justify-end tw-space-x-2">
          <a-input
            v-model="search"
            v-tooltip="$t('candidateCertificate.search')"
            :placeholder="$t('candidateCertificate.search')"
            style="width: 250px"
            class="inline-block"
          />
          <a-button v-tooltip="$t('filter')" @click.prevent="visible = true">
            <i class="fa fa-filter"></i>
          </a-button>
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'examination_event',
          }"
        >
          <template v-slot="{ record }">
            <td class="tw-text-center tw-whitespace-nowrap">
              {{ record.branch.prefix_code }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.certificate_number }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.fname_en }} {{ record.lname_en }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.fname_kh }} {{ record.lname_kh }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.sex }}
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.phone }}
            </td>
            <td class="text-center tw-whitespace-nowrap">
              {{ record.cert_type_name }}
            </td>
            <td class="text-center tw-whitespace-nowrap">
              {{ record.issue_date }}
            </td>
            <td class="text-center tw-whitespace-nowrap">
              {{ record.expire_date }}
            </td>
            <td class="text-center tw-whitespace-nowrap">
              {{ record.available_in_year }}
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4 tw-wh">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>
    <a-drawer
      :title="$t('filter')"
      :closable="false"
      :visible="visible"
      :zIndex="1020"
      @close="() => (visible = false)"
      width="300px"
    >
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t("testingCenter")
        }}</label>
        <ts-branch-filter @filter="(value) => (branch_id = value)" />
      </div>
      <div class="mb-3">
        <label class="form-col-label control-label">{{
          $t("candidateCertificate.issuedDate")
        }}</label>
        <a-range-picker
          v-model="dateRange"
          :allowClear="false"
          format="DD-MM-YYYY"
          valueFormat="DD-MM-YYYY"
          @change="fetchData()"
        />
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
export default {
  name: "candidateCertificateIndex",
  data() {
    return {
      loading: false,
      showForm: false,
      deleting: false,
      visible: false,
      branch_id: [],
    };
  },
  computed: {
    ...mapState("academic/candidateCertificate", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.academic.candidateCertificate.search;
      },
      set(newValue) {
        this.$store.commit(
          "academic/candidateCertificate/SET_SEARCH",
          newValue
        );
        this.$store.commit("academic/candidateCertificate/RESET_CURRENT_PAGE");
      },
    },
    dateRange: {
      get() {
        return this.$store.state.academic.candidateCertificate.dateRange;
      },
      set(newValue) {
        this.$store.commit(
          "academic/candidateCertificate/SET_DATE_RANGE",
          newValue
        );
      },
    },
    columns() {
      return [
        {
          name: this.$t("candidateCertificate.testingCenter"),
          style: "text-align:center;width:150px;white-space: nowrap;",
        },
        {
          name: this.$t("candidateCertificate.certificateNumber"),
          style: "white-space: nowrap",
        },
        {
          name: this.$t("candidateCertificate.nameEn"),
          style: "white-space: nowrap",
        },
        {
          name: this.$t("candidateCertificate.nameKh"),
          style: "white-space: nowrap",
        },
        {
          name: this.$t("candidateCertificate.sex"),
          style: "white-space: nowrap",
        },
        {
          name: this.$t("candidateCertificate.phone"),
          style: "white-space: nowrap",
        },
        {
          name: this.$t("candidateCertificate.cetificateType"),
          style: "text-align:center;white-space: nowrap",
        },
        {
          name: this.$t("candidateCertificate.issuedDate"),
          style: "text-align:center;white-space: nowrap;width: 100px",
        },
        {
          name: this.$t("candidateCertificate.expiredDate"),
          style: "width: 150px;text-align:center;white-space: nowrap",
        },
        {
          name: this.$t("candidateCertificate.availableInYear"),
          style: "width: 150px;text-align:center;white-space: nowrap",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/candidateCertificate/fetch", {
          ...attributes,
          branch_id: this.branch_id,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    clearEdit() {
      this.$store.commit("academic/candidateCertificate/SET_EDIT_DATA", {});
      this.showForm = false;
      this.fetchData();
    },
    deleteRecord(record) {
      this.deleting = true;
      this.$store
        .dispatch(
          "academic/candidateCertificate/destroy",
          record.exam_register_id
        )
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.deleting = false;
        });
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value });
    }, 500),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/candidateCertificate/RESET_STATE");
    next();
  },
};
</script>

<style lang="scss" scoped>
</style>